import produce from 'immer';
import React from 'react';
import {
  getCarePlanById,
  getCarePlanByPatientId,
} from '../../../apis/carePlan';
import { CarePlanContext, ICarePlanContext } from '../../../contexts/carePlan';
import { ICarePlan } from '../../../modules/unsw-fhir/CarePlan';

type CarePlanProviderProps = {
  carePlanId?: string;
  patientId?: string;
  initialCarePlan?: ICarePlan;
};

type CarePlanProviderState = ICarePlanContext;

export default class CarePlanProvider extends React.PureComponent<
  CarePlanProviderProps,
  CarePlanProviderState
> {
  constructor(props: CarePlanProviderProps) {
    super(props);

    this.state = {
      loading: false,
      carePlan: props.initialCarePlan,
      setCarePlan: this.setCarePlan,
    };
  }

  componentDidUpdate = async (prevProps: CarePlanProviderProps) => {
    if (
      prevProps.carePlanId !== this.props.carePlanId ||
      prevProps.patientId !== this.props.patientId
    )
      await this.updateCarePlan();
  };

  componentDidMount = async () => {
    if (!this.props.carePlanId && !this.props.patientId) return;
    await this.updateCarePlan();
  };

  render = () => {
    return (
      <CarePlanContext.Provider value={this.state}>
        {this.props.children}
      </CarePlanContext.Provider>
    );
  };

  private updateCarePlan = async () => {
    try {
      this.setState(state =>
        produce(state, draft => {
          draft.loading = true;
        }),
      );

      const carePlan = this.props.patientId
        ? await getCarePlanByPatientId(this.props.patientId)
        : this.props.carePlanId
        ? await getCarePlanById(this.props.carePlanId)
        : this.props.initialCarePlan;

      this.setState(state =>
        produce(state, draft => {
          draft.carePlan = carePlan;
        }),
      );
    } catch (e) {
      this.setState(state =>
        produce(state, draft => {
          draft.error = e as string | undefined;
        }),
      );
    } finally {
      this.setState(state =>
        produce(state, draft => {
          draft.loading = false;
        }),
      );
    }
  };

  private setCarePlan = (carePlan?: ICarePlan) =>
    new Promise<void>(resolve => {
      this.setState(
        state =>
          produce(state, draft => {
            draft.carePlan = carePlan;
          }),
        resolve,
      );
    });
}
